import { render, staticRenderFns } from "./ProductSortFilter.vue?vue&type=template&id=6899e784"
import script from "./ProductSortFilter.vue?vue&type=script&lang=js"
export * from "./ProductSortFilter.vue?vue&type=script&lang=js"
import style0 from "./ProductSortFilter.vue?vue&type=style&index=0&id=6899e784&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports